import { useEffect, useState, createContext, useContext } from 'react';
import { supabase } from '../utils/supabaseClient';

type SessionState = {
  user: { id: string; email?: string | null } | null;
  loading: boolean;
};
const SessionCtx = createContext<SessionState>({ user: null, loading: true });

export function SessionProvider({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<SessionState>({ user: null, loading: true });

  useEffect(() => {
    const init = async () => {
      const { data } = await supabase.auth.getUser();
      setState({ user: data.user ? { id: data.user.id, email: data.user.email } : null, loading: false });
    };
    init();
    const { data: sub } = supabase.auth.onAuthStateChange((_event, session) => {
      setState({ user: session?.user ? { id: session.user.id, email: session.user.email } : null, loading: false });
    });

    // Auto-refresh session every 30 minutes to prevent timeout on Vercel
    const refreshInterval = setInterval(async () => {
      const { data: { session } } = await supabase.auth.getSession();
      if (session) {
        // Trigger token refresh
        await supabase.auth.refreshSession();
      }
    }, 30 * 60 * 1000); // 30 minutes

    return () => { 
      sub.subscription.unsubscribe(); 
      clearInterval(refreshInterval);
    };
  }, []);

  return <SessionCtx.Provider value={state}>{children}</SessionCtx.Provider>;
}

export function useSession() {
  return useContext(SessionCtx);
}
